// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import GardenAdviceResourceViewModel from '../../../../viewModel/resource/GardenAdviceResourceViewModel';
import GardenCertificationResourceViewModel from '../../../../viewModel/resource/GardenCertificationResourceViewModel';
import NimSContactDataResourceViewModel from '../../../../viewModel/resource/NimSContactDataResourceViewModel';
import AddressViewModel from '../../../../viewModel/resource/AddressViewModel';
import NimSContactCommunicationResourceViewModel from '../../../../viewModel/resource/NimSContactCommunicationResourceViewModel';
import RequestSummaryResourceViewModel from '../../../../viewModel/resource/RequestSummaryResourceViewModel';
import NimSRegistrationRequestViewModel from '../../../../viewModel/resource/NimSRegistrationRequestViewModel';
import NimSRegistrationRequestDTO from '../../dto/resource/NimSRegistrationRequestDTO';

export default abstract class NimSRegistrationRequestModel extends BaseModel<NimSRegistrationRequestDTO> {
  /**
  * @type {uuid}
  */
  get natureOffer() { return this.dto.natureOffer; }
  set natureOffer(value) { this.dto.natureOffer = value; }
  /**
  */
  get gardenAdvice() { return this.getObjectModel(() => this.dto.gardenAdvice, GardenAdviceResourceViewModel)!; }
  set gardenAdvice(value) { this.setObjectModel(() => this.dto.gardenAdvice, value); }
  /**
  */
  get gardenCertification() { return this.getObjectModel(() => this.dto.gardenCertification, GardenCertificationResourceViewModel)!; }
  set gardenCertification(value) { this.setObjectModel(() => this.dto.gardenCertification, value); }
  /**
  */
  get remarks() { return this.dto.remarks; }
  set remarks(value) { this.dto.remarks = value; }
  /**
  * @type {int32}
  */
  get gardenSize() { return this.dto.gardenSize; }
  set gardenSize(value) { this.dto.gardenSize = value; }
  /**
  * @type {uuid}
  */
  get gardenType() { return this.dto.gardenType; }
  set gardenType(value) { this.dto.gardenType = value; }
  /**
  */
  get isGardenOwner() { return this.dto.isGardenOwner; }
  set isGardenOwner(value) { this.dto.isGardenOwner = value; }
  /**
  */
  get hasAcceptedRegulations() { return this.dto.hasAcceptedRegulations; }
  set hasAcceptedRegulations(value) { this.dto.hasAcceptedRegulations = value; }
  /**
  */
  get contactData() { return this.getObjectModel(() => this.dto.contactData, NimSContactDataResourceViewModel)!; }
  set contactData(value) { this.setObjectModel(() => this.dto.contactData, value); }
  /**
  */
  get isGardenAddressNotContactDataAddress() { return this.dto.isGardenAddressNotContactDataAddress; }
  set isGardenAddressNotContactDataAddress(value) { this.dto.isGardenAddressNotContactDataAddress = value; }
  /**
  */
  get gardenAddress() { return this.getObjectModel(() => this.dto.gardenAddress, AddressViewModel)!; }
  set gardenAddress(value) { this.setObjectModel(() => this.dto.gardenAddress, value); }
  /**
  */
  get communicationData() { return this.getObjectModel(() => this.dto.communicationData, NimSContactCommunicationResourceViewModel)!; }
  set communicationData(value) { this.setObjectModel(() => this.dto.communicationData, value); }
  /**
  */
  get communicationTime() { return this.dto.communicationTime; }
  set communicationTime(value) { this.dto.communicationTime = value; }
  /**
  * @type {uuid}
  */
  get nimSLanguageId() { return this.dto.nimSLanguageId; }
  set nimSLanguageId(value) { this.dto.nimSLanguageId = value; }
  /**
  */
  get userLanguage() { return this.dto.userLanguage; }
  set userLanguage(value) { this.dto.userLanguage = value; }
  /**
  */
  get hasAcceptedMarketing() { return this.dto.hasAcceptedMarketing; }
  set hasAcceptedMarketing(value) { this.dto.hasAcceptedMarketing = value; }
  /**
  */
  get summary() { return this.getObjectModel(() => this.dto.summary, RequestSummaryResourceViewModel)!; }
  set summary(value) { this.setObjectModel(() => this.dto.summary, value); }
  /**
  */
  get hasAcceptedGdpr() { return this.dto.hasAcceptedGdpr; }
  set hasAcceptedGdpr(value) { this.dto.hasAcceptedGdpr = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.natureOffer = qs.natureoffer;
    this.dto.remarks = qs.remarks;
    value = Number.parseFloat(qs.gardensize);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.gardenSize = value;
    this.dto.gardenType = qs.gardentype;
    value = qs.isGardenOwner === 'true' ? true : qs.isgardenowner;
    value = qs.isGardenOwner === 'false' ? false : undefined;
    this.dto.isGardenOwner = value;
    value = qs.hasAcceptedRegulations === 'true' ? true : qs.hasacceptedregulations;
    value = qs.hasAcceptedRegulations === 'false' ? false : undefined;
    this.dto.hasAcceptedRegulations = value;
    value = qs.isGardenAddressNotContactDataAddress === 'true' ? true : qs.isgardenaddressnotcontactdataaddress;
    value = qs.isGardenAddressNotContactDataAddress === 'false' ? false : undefined;
    this.dto.isGardenAddressNotContactDataAddress = value;
    this.dto.communicationTime = qs.communicationtime;
    this.dto.nimSLanguageId = qs.nimslanguageid;
    this.dto.userLanguage = qs.userlanguage;
    value = qs.hasAcceptedMarketing === 'true' ? true : qs.hasacceptedmarketing;
    value = qs.hasAcceptedMarketing === 'false' ? false : undefined;
    this.dto.hasAcceptedMarketing = value;
    value = qs.hasAcceptedGdpr === 'true' ? true : qs.hasacceptedgdpr;
    value = qs.hasAcceptedGdpr === 'false' ? false : undefined;
    this.dto.hasAcceptedGdpr = value;
  }
}
